"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfoBoxStateReducer = exports.infoBoxStateReducer = exports.selectTab = exports.expandItem = exports.expandMenu = exports.InfoBoxStateActionType = void 0;
const react_1 = require("react");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
var InfoBoxStateActionType;
(function (InfoBoxStateActionType) {
    InfoBoxStateActionType["ExpandMenu"] = "expandMenu";
    InfoBoxStateActionType["ExpandItem"] = "expandItem";
    InfoBoxStateActionType["SelectTab"] = "selectTab";
})(InfoBoxStateActionType || (exports.InfoBoxStateActionType = InfoBoxStateActionType = {}));
const expandMenu = (state) => ({
    type: InfoBoxStateActionType.ExpandMenu,
    payload: state,
});
exports.expandMenu = expandMenu;
const expandItem = (state) => ({
    type: InfoBoxStateActionType.ExpandItem,
    payload: state,
});
exports.expandItem = expandItem;
const selectTab = (tab) => ({
    type: InfoBoxStateActionType.SelectTab,
    payload: tab,
});
exports.selectTab = selectTab;
function infoBoxStateReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case InfoBoxStateActionType.ExpandMenu:
            return Object.assign(Object.assign({}, state), { isExpanded: payload });
        case InfoBoxStateActionType.ExpandItem:
            return Object.assign(Object.assign({}, state), { isExpandedItem: payload });
        case InfoBoxStateActionType.SelectTab: {
            const previousTab = state.currentTab;
            return Object.assign(Object.assign({}, state), { previousTab, currentTab: payload === previousTab
                    ? bridge_schema_1.InfoBoxTabType.None
                    : payload });
        }
        default:
            return state;
    }
}
exports.infoBoxStateReducer = infoBoxStateReducer;
function useInfoBoxStateReducer(state) {
    return (0, react_1.useReducer)(infoBoxStateReducer, state);
}
exports.useInfoBoxStateReducer = useInfoBoxStateReducer;
